import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import AjaxErrorBoundary from '../../ajax/errorBoundary';
import { IModeratorPageRouteParams } from './types';
import { useDataFetcher } from '../../hooks';
import {
  Answer,
  IDriverEvaluationReport,
} from '../driverEvaluationReport/types';
import DriverEvaluationReport from '../driverEvaluationReport/DriverEvaluationReport';
import ErrorList from '../../errorList';
import updateResults from './updateResults';
import fetchResults from '../driverEvaluationReport/fetchResults';

const ModeratorPage: React.FC = () => {
  const { id } = useParams<IModeratorPageRouteParams>();

  const [token, setToken] = useState<string>('');
  const [report, setReport] = useState<IDriverEvaluationReport>({
    bookingFileId: 0,
    isAssessor: false,
    attendanceConfirmed: false,
    resultsSubmitted: false,
    groups: [],
  });

  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
    const [ajaxErrors, setAjaxErrors] = useState<Array<string>>([]);
    const [reportBusy, setReportBusy] = useState<boolean>(false); // 45915 - TO - 15/11/2024
    const [isFetchingOverallAssessmentGrades, setIsFetchingOverallAssessmentGrades] = useState<boolean>(false); // 45915 - TO - 15/11/2024
    const [reportErrors, setReportErrors] = useState<Array<string>>([]); // 45915 - TO - 15/11/2024


  const { busy, errors, data } = useDataFetcher(
    `/api/driverEvaluations/${id}/moderator`,
  );

  useEffect(() => {
    if (data) {
      setToken(data.token);
      setReport(data.report);
    }
    // 45915 - TO - 15/11/2024
    if (errors) {
        setReportErrors(errors);
    }
    // 45915 - TO - 15/11/2024
    setReportBusy(busy);
  }, [data, errors, busy]);

  useLayoutEffect(() => {
    if (ajaxErrors.length > 0) {
      window.scrollTo(0, 0);
    }
  }, [ajaxErrors]);

  useLayoutEffect(() => {
    if (ajaxErrors.length > 0) {
      window.scrollTo(0, 0);
    }
  }, [ajaxErrors]);

  const handleReportUpdated = (results: Array<Answer>, complete: boolean) => {
    setIsSaving(true);

    updateResults({ id, token, results, complete })
      .then(() => setIsComplete(complete))
      .catch(setAjaxErrors)
      .finally(() => setIsSaving(false));
  };

    // 45915 - TO - 15/11/2024
    const handleFetchingOverallAssessmentGrades = (results: Array<Answer>, complete: boolean) => {
        setIsFetchingOverallAssessmentGrades(true);

        updateResults({ id, token, results, complete })
            .then(response => {
                setIsComplete(complete);

                if (id) {
                    setReportBusy(true);
                    fetchResults(parseInt(id))
                        .then(res => setReport(res.data))
                        .catch(setReportErrors)
                        .finally(() => setReportBusy(false));
                }
            })
            .catch(setAjaxErrors)
            .finally(() => setIsFetchingOverallAssessmentGrades(false));
    };

    return (
        <AjaxErrorBoundary busy={reportBusy} errors={reportErrors} loadingText="Loading">
      {report.groups.length > 0 && (
        <div className="container">
          <div className="my-4">
            <h2>Driver Evaluation Report</h2>
            <ErrorList errors={ajaxErrors} />
            <DriverEvaluationReport
                          isAssessor
                          attendanceConfirmed={report.attendanceConfirmed}
                          resultsSubmitted={report.resultsSubmitted || isComplete}
                          groups={report.groups}
                          busy={isSaving}
                          pdfUrl={''}
                          requiresAttention={false}
                          onReportUpdated={handleReportUpdated}
                          handleFetchingOverallAssessmentGrades={handleFetchingOverallAssessmentGrades} // 45915 - TO - 15/11/2024
                          fetchingOverallAssessmentGrades={isFetchingOverallAssessmentGrades} // 45915 - TO - 15/11/2024
            />
          </div>
        </div>
      )}
    </AjaxErrorBoundary>
  );
};

export default ModeratorPage;
